module.exports = __webpack_public_path__ + "static/6305-woodrose-13-78ac00898d6c4497f4d055a741da6c91.jpg";